import axios from '@/lib/axios';
import {useMutation} from '@tanstack/react-query';

type Props = {
  token: string;
  pin_code: string;
  password: string;
}

const updatePasswordReset = (props: Props): Promise<any> => {
  return axios.put(`/api/user_password_resets/${props.token}`, props);
};

export const useUpdatePasswordReset = () => {
  return useMutation({
    mutationFn: updatePasswordReset
  })
}